import React from "react"
import ProgressiveImage from "react-progressive-image"
import { asyncComponent } from "react-async-component"
import glamorous from "glamorous"

//import Search from "./Search"

const Search = asyncComponent({
  resolve: () => import("./Search"),
  LoadingComponent: ({ productId }) => <div>Loading {productId}</div>, // Optional
  ErrorComponent: ({ error }) => <div>{error.message}</div>, // Optional
})

const Jumbo = props => (
  <Wrapper>
    <ImageContainer>
      <StyledProgressiveImage />
    </ImageContainer>
    <Heading>Find the best camp for your camper</Heading>
    <Search />
  </Wrapper>
)

const Heading = glamorous.h1({
  fontSize: "3em",
  color: "white",
})

const Wrapper = glamorous.div({
  position: "relative",
  padding: 60,
  paddingTop: 110,
  paddingBottom: 110,
  overflow: "hidden",
})

const ProgressiveImageFactory = ({ className, children }) => (
  <ProgressiveImage src="forest3-min.jpg" placeholder="forest3-min-blur.jpg">
    {src => <img alt="" className={className} src={src} />}
  </ProgressiveImage>
)

const StyledProgressiveImage = glamorous(ProgressiveImageFactory)({
  position: "absolute",
  top: 0,
  left: 0,
  overflow: "hidden",
  "@media (min-width: 700px)": {
    width: "100%",
  },
  "@media (max-width: 700px)": {
    height: "100%",
  },
})

const ImageContainer = glamorous.div({
  position: "absolute",
  overflow: "hidden",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  zIndex: "-1",
})

export default Jumbo



// WEBPACK FOOTER //
// ./src/scenes/Home/Jumbo.js